(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 598:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Df: () => (/* binding */ getVisibleTabbableElements),
/* harmony export */   xU: () => (/* binding */ focusNextVisibleTabbableElement)
/* harmony export */ });
/* unused harmony export updateAbleKeyboardTrap */
var updateAbleKeyboardTrap = function updateAbleKeyboardTrap(updateAbleKeyboardTrapConfig) {
  if (!updateAbleKeyboardTrapConfig || updateAbleKeyboardTrapConfig.moveFocusIntoComponent) {
    window.dispatchEvent(new CustomEvent('focusMovedIntoComponent'));
  }
  window.dispatchEvent(new CustomEvent('reIndexKeyboardTrap'));
};
var getVisibleTabbableElements = function getVisibleTabbableElements(container) {
  return Array.from(container.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')).filter(function (tabbableElement) {
    return tabbableElement.offsetParent && window.getComputedStyle(tabbableElement).visibility !== 'hidden';
  });
};
var focusNextVisibleTabbableElement = function focusNextVisibleTabbableElement(event, visibleTabbableElements) {
  if (event.key === 'Tab') {
    var currentlySelectedTabbableElementIndex = -1;
    if (document.activeElement) {
      currentlySelectedTabbableElementIndex = visibleTabbableElements.indexOf(document.activeElement);
    }
    event.preventDefault();
    var nextIndex = 0;
    if (currentlySelectedTabbableElementIndex > -1) {
      if (event.key === 'Tab' && !event.shiftKey) {
        if (currentlySelectedTabbableElementIndex + 1 < visibleTabbableElements.length) {
          nextIndex = currentlySelectedTabbableElementIndex + 1;
        }
      }
      if (event.key === 'Tab' && event.shiftKey) {
        if (currentlySelectedTabbableElementIndex - 1 > -1) {
          nextIndex = currentlySelectedTabbableElementIndex - 1;
        } else {
          nextIndex = visibleTabbableElements.length - 1;
        }
      }
    } else {
      if (event.key === 'Tab' && event.shiftKey) {
        // shift tab before we have entered the keyboard trap goes to last element
        nextIndex = visibleTabbableElements.length - 1;
      }
    }
    var elementReceivingFocus = visibleTabbableElements[nextIndex];
    elementReceivingFocus.focus();
  }
};

/***/ }),

/***/ 1116:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 1217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   G: () => (/* binding */ iconVersion)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1116);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    _props$size = props.size,
    size = _props$size === void 0 ? '24' : _props$size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  var deprecatedIcons = {
    Visibility: ['ToggleOff, ToggleOn'],
    ScanBarcode: ['Scan']
  };
  var replacementIcons = icon;
  if (deprecatedIcons.hasOwnProperty(icon)) {
    replacementIcons = deprecatedIcons[icon].join(' ');
    console.warn("Icon ".concat(icon, " is deprecated, and will be removed in July 2024. Use '").concat(replacementIcons, "' instead."));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 2015:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 2395:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: () => (/* binding */ convertKeyValuesIntoDataAttributes)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7826);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);

var convertKeyValuesIntoDataAttributes = function convertKeyValuesIntoDataAttributes(attributes) {
  var attributesAsArray = Object.entries(attributes).map(function (_ref) {
    var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return ["data-".concat(key), value];
  });
  return Object.fromEntries(attributesAsArray);
};


/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 2700:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1116);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4822);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_router_dom__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["children", "className", "element", "elementRef", "events", "externalSite", "opensNewTab", "href", "type", "to", "state", "ariaDisabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/**
 * InteractiveElement is a component partial which can render anchors, buttons, React Links & NavLink
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/Action+List
 * @version 1.0.0
 */

function InteractiveElement(props) {
  var children = props.children,
    className = props.className,
    element = props.element,
    elementRef = props.elementRef,
    events = props.events,
    _props$externalSite = props.externalSite,
    externalSite = _props$externalSite === void 0 ? false : _props$externalSite,
    _props$opensNewTab = props.opensNewTab,
    opensNewTab = _props$opensNewTab === void 0 ? false : _props$opensNewTab,
    href = props.href,
    _props$type = props.type,
    type = _props$type === void 0 ? 'button' : _props$type,
    to = props.to,
    state = props.state,
    ariaDisabled = props.ariaDisabled,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var filteredOpensNewTab = opensNewTab || externalSite;
  if (!filteredOpensNewTab) {
    if (events) {
      if (events.rel) {
        delete events.rel;
      }
      if (events.target && events.target === '_blank') {
        delete events.target;
      }
    }
  }
  var filteredTarget = element && element !== 'button' && filteredOpensNewTab ? '_blank' : undefined;
  var elementProps = _objectSpread(_objectSpread(_objectSpread({}, events), other), {}, {
    className: className,
    ref: elementRef,
    'aria-disabled': ariaDisabled,
    target: filteredTarget,
    rel: filteredOpensNewTab ? 'noopener noreferrer' : undefined
  });
  var targetURL = href || to || '/';
  if (element === 'a') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      href: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  if (element === 'Link') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.Link, _objectSpread(_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      state: state,
      children: children
    }));
  }
  if (element === 'NavLink') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_router_dom__WEBPACK_IMPORTED_MODULE_2__.NavLink, _objectSpread(_objectSpread({
      to: targetURL
    }, elementProps), {}, {
      children: children
    }));
  }
  return (
    /*#__PURE__*/
    // https://github.com/yannickcr/eslint-plugin-react/issues/1555
    // eslint-disable-next-line react/button-has-type
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", _objectSpread(_objectSpread({
      type: type
    }, elementProps), {}, {
      children: children
    }))
  );
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InteractiveElement);

/***/ }),

/***/ 2708:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   F: () => (/* binding */ isDialog)
/* harmony export */ });
var isDialog = function isDialog(child) {
  var role = child.getAttribute('role');
  return role && role === 'dialog';
};

/**
 * Returns a map of children as key and the ariaHidden value as value
 */
var storeCurrentBodyChildrenAriaHiddenValue = function storeCurrentBodyChildrenAriaHiddenValue() {
  var _document = document,
    body = _document.body;
  var elementsAttributesMap = new Map();
  var bodyChildren = Array.from(body.children);
  bodyChildren.forEach(function (child) {
    if (child.nodeName !== 'SCRIPT' && !isDialog(child)) {
      var childIsAriaHidden = child.ariaHidden;
      elementsAttributesMap.set(child, childIsAriaHidden);
    }
  });
  return elementsAttributesMap;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (storeCurrentBodyChildrenAriaHiddenValue);

/***/ }),

/***/ 4822:
/***/ ((module) => {

"use strict";
module.exports = require("react-router-dom");

/***/ }),

/***/ 4848:
/***/ (() => {



/***/ }),

/***/ 5133:
/***/ (() => {



/***/ }),

/***/ 6168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1217);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5133);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);

/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 6963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_ActionButton)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/_shared/_partials/ButtonArrowIcon/index.tsx

/**
 *
 * ArrowIcon is a component partial used in some interaction patterns.
 *
 * @link https://confluence.tools.telstra.com/display/DCSYS/Action+List
 * @param {string} className custom classname
 * @version 1.0.0
 */

var ButtonArrowIcon = function ButtonArrowIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", {
    className: className,
    version: "1.1",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m21.71,12.71h0,0m-.71-1.71c-.26,0-.51.1-.71.29l-5.29,5.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l5.29-5.29c.39-.39.39-1.02,0-1.41-.2-.2-.45-.29-.71-.29h0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.71,5.71c-.26,0-.51.1-.71.29-.39.39-.39,1.02,0,1.41l5.29,5.29c.2.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41l-5.29-5.29c-.2-.2-.45-.29-.71-.29h0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19,11H6c-.55,0-1,.45-1,1s.45,1,1,1h13c.55,0,1-.45,1-1s-.45-1-1-1h0Z"
      })
    })]
  });
};
/* harmony default export */ const _partials_ButtonArrowIcon = (ButtonArrowIcon);
// EXTERNAL MODULE: ./src/_shared/_partials/InteractiveElement/index.tsx
var InteractiveElement = __webpack_require__(2700);
;// ./src/_shared/_partials/OpensNewTabSrOnlySpan/index.tsx

/**
 *
 * OpensNewTabSrOnlySpan is a component partial used by ActionButton and ActionListItem
 *
 */

var OpensNewTabSrOnlySpan = function OpensNewTabSrOnlySpan() {
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
    className: "able-sr-only",
    children: ", opens new tab"
  });
};
/* harmony default export */ const _partials_OpensNewTabSrOnlySpan = (OpensNewTabSrOnlySpan);
// EXTERNAL MODULE: ./src/_shared/_helpers/convertKeyValuesIntoDataAttributes.ts
var convertKeyValuesIntoDataAttributes = __webpack_require__(2395);
// EXTERNAL MODULE: ./src/Icon/Icon.tsx
var Icon = __webpack_require__(1217);
;// ./src/ActionButton/ActionButton.tsx


var _excluded = ["className", "deleteIcon", "developmentUrl", "icon", "label", "variant", "includeScreenReaderOpenInNewTabText", "includeAbleClassnames", "ref", "elementRef", "opensNewTab", "externalSite", "element", "dataAttributesKeyValuePairs", "useTouchTargetSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }







/**
 * Action buttons are used as a cue to perform actions or navigate within a flow,
 * the user can interact by clicking on the button.
 *
 * [View the Action Button pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Action+Button)
 *
 * @version 1.0.0
 */

function ActionButton(props) {
  var className = props.className,
    deleteIcon = props.deleteIcon,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    label = props.label,
    variant = props.variant,
    includeScreenReaderOpenInNewTabText = props.includeScreenReaderOpenInNewTabText,
    _props$includeAbleCla = props.includeAbleClassnames,
    includeAbleClassnames = _props$includeAbleCla === void 0 ? true : _props$includeAbleCla,
    ref = props.ref,
    elementRef = props.elementRef,
    opensNewTab = props.opensNewTab,
    externalSite = props.externalSite,
    element = props.element,
    dataAttributesKeyValuePairs = props.dataAttributesKeyValuePairs,
    _props$useTouchTarget = props.useTouchTargetSize,
    useTouchTargetSize = _props$useTouchTarget === void 0 ? 48 : _props$useTouchTarget,
    other = objectWithoutProperties_default()(props, _excluded);
  var ableVariants = {
    LowEmphasis: {
      cssName: 'low-emphasis',
      hasArrow: true,
      allowsIcon: true
    },
    LowEmphasisBig: {
      cssName: 'low-emphasis-big',
      hasArrow: true,
      allowsIcon: true
    },
    Destructive: {
      cssName: 'destructive',
      hasArrow: true,
      allowsIcon: false
    },
    MediumEmphasis: {
      cssName: 'medium-emphasis',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasis: {
      cssName: 'high-emphasis',
      hasArrow: false,
      allowsIcon: false
    },
    MediumEmphasisCompact: {
      cssName: 'medium-emphasis-compact',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasisCompact: {
      cssName: 'high-emphasis-compact',
      hasArrow: false,
      allowsIcon: false
    },
    HighEmphasisDestructive: {
      cssName: 'high-emphasis-destructive',
      hasArrow: false,
      allowsIcon: false
    }
  };
  var includeTouchTargetSize = useTouchTargetSize === 32 && (variant === 'LowEmphasis' || variant === 'LowEmphasisBig' || variant === 'Destructive');
  var classes = includeAbleClassnames ? classnames_default()('able-ActionButton', "able-ActionButton--".concat(ableVariants[variant].cssName).concat(includeTouchTargetSize ? ' able-ActionButton--TouchTargetSize' : ''), className) : classnames_default()(className);
  var showDeleteIcon = deleteIcon && variant === 'Destructive';
  var isArrowVariant = ableVariants[variant].hasArrow;
  var filteredOpensNewTab = element.toLowerCase() !== 'button' && (opensNewTab || includeScreenReaderOpenInNewTabText || externalSite);
  if (filteredOpensNewTab && variant === 'Destructive') {
    console.warn('ActionButton opensNewTab is deprecated for the Destructive variant and will be removed in the future.');
  }
  var filteredDataAttributes = dataAttributesKeyValuePairs ? (0,convertKeyValuesIntoDataAttributes/* convertKeyValuesIntoDataAttributes */.c)(dataAttributesKeyValuePairs) : '';
  var opensNewTabSrOnlySpan;
  if (filteredOpensNewTab && !isArrowVariant) {
    opensNewTabSrOnlySpan = /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_OpensNewTabSrOnlySpan, {});
  }
  var spriteSheetUrl = developmentUrl ? developmentUrl : '//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v' + Icon/* iconVersion */.G;
  var generateIcon = function generateIcon(icon, screenReaderContent) {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", {
      className: "able-icon",
      role: "img",
      "aria-hidden": screenReaderContent ? 'false' : 'true',
      "aria-label": screenReaderContent ? screenReaderContent : undefined,
      focusable: "false",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("use", {
        href: "".concat(spriteSheetUrl, "#").concat(icon)
      })
    });
  };
  var customIcon, arrowIcon;
  if (isArrowVariant && filteredOpensNewTab) {
    arrowIcon = generateIcon('OpenExternalThicker', ', opens new tab');
  } else {
    if (variant === 'Destructive' && showDeleteIcon) {
      customIcon = generateIcon('Delete');
    } else {
      if (icon && ableVariants[variant].allowsIcon) {
        customIcon = generateIcon(icon);
      } else if (isArrowVariant && !showDeleteIcon) {
        arrowIcon = /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_ButtonArrowIcon, {});
      }
    }
  }
  var buttonChildren = function buttonChildren() {
    return /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
      children: [customIcon, "".concat(label), opensNewTabSrOnlySpan, arrowIcon]
    });
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(InteractiveElement/* default */.A, _objectSpread(_objectSpread(_objectSpread({}, other), filteredDataAttributes), {}, {
    element: element,
    className: classes,
    opensNewTab: filteredOpensNewTab,
    elementRef: ref || elementRef,
    children: buttonChildren()
  }));
}
/* harmony default export */ const ActionButton_ActionButton = (ActionButton);
// EXTERNAL MODULE: ./src/ActionButton/ActionButton.scss
var src_ActionButton_ActionButton = __webpack_require__(7163);
;// ./src/ActionButton/index.ts


/* harmony default export */ const src_ActionButton = (ActionButton_ActionButton);

/***/ }),

/***/ 7163:
/***/ (() => {



/***/ }),

/***/ 7826:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ 7962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ useDisableBodyScroll),
/* harmony export */   y: () => (/* binding */ useKeyboardTrap)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2015);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _functions_storeCurrentBodyChildrenAriaHiddenValues__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2708);
/* harmony import */ var _shared_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(598);



var useKeyboardTrap = function useKeyboardTrap(containerRef, isShowing, focusOnOpenRef) {
  var visibleTabbableElements = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    var container = containerRef.current;
    if (container) {
      visibleTabbableElements.current = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibleTabbableElements */ .Df)(container);
      var handleKeyDown = function handleKeyDown(e) {
        (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_1__/* .focusNextVisibleTabbableElement */ .xU)(e, visibleTabbableElements.current);
      };
      var handleMouseDown = function handleMouseDown(event) {
        if (container !== null && container !== void 0 && container.contains(event.target)) {
          var currentFocusIndex = visibleTabbableElements.current.findIndex(function (element) {
            return element === document.activeElement;
          });
          if (currentFocusIndex > 0) {
            visibleTabbableElements.current[currentFocusIndex].focus();
          }
        }
      };
      var focusMovedIntoComponent = function focusMovedIntoComponent() {
        if (focusOnOpenRef && focusOnOpenRef.current) {
          focusOnOpenRef.current.focus();
        }
      };
      var reIndexKeyboardTrap = function reIndexKeyboardTrap() {
        visibleTabbableElements.current = (0,_shared_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getVisibleTabbableElements */ .Df)(container);
      };
      if (isShowing) {
        container.addEventListener('keydown', handleKeyDown);
        container.addEventListener('mousedown', handleMouseDown);
        window.addEventListener('focusMovedIntoComponent', focusMovedIntoComponent);
        window.addEventListener('reIndexKeyboardTrap', reIndexKeyboardTrap);
      } else {
        container.removeEventListener('keydown', handleKeyDown);
        container.removeEventListener('mousedown', handleMouseDown);
        window.removeEventListener('focusMovedIntoComponent', focusMovedIntoComponent);
        window.removeEventListener('reIndexKeyboardTrap', reIndexKeyboardTrap);
      }
    }
  }, [isShowing, containerRef]);
};

/*This hook should only be used inside RenderDialog component*/
var useDisableBodyScroll = function useDisableBodyScroll() {
  var ariaHiddenValues = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  ariaHiddenValues.current = (0,_functions_storeCurrentBodyChildrenAriaHiddenValues__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    var _document = document,
      body = _document.body;
    // don't allow scrolling on body
    body.style.overflow = 'hidden';
    // remove other elements from tabindex and screen readers
    Array.from(body.children).forEach(function (child) {
      if (child.nodeName !== 'SCRIPT' && !(0,_functions_storeCurrentBodyChildrenAriaHiddenValues__WEBPACK_IMPORTED_MODULE_2__/* .isDialog */ .F)(child)) {
        child.setAttribute('aria-hidden', 'true');
      }
    });
    return function () {
      // allow scroll on body
      body.style.overflow = 'auto';
      // reinstate original ariaHidden value
      Array.from(body.children).forEach(function (child) {
        if (typeof ariaHiddenValues.current !== 'undefined' && ariaHiddenValues.current.has(child)) {
          var value = ariaHiddenValues.current.get(child);
          if (value) {
            child.setAttribute('aria-hidden', value);
          } else {
            child.removeAttribute('aria-hidden');
          }
        }
      });
    };
  }, []);
};

/***/ }),

/***/ 8109:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_ModalDialog)
});

// UNUSED EXPORTS: createClickHandler, createCollatedEvents, dialogStateStorybookArgTypes, useDisableBodyScroll, useKeyboardTrap

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
;// external "react-dom"
const external_react_dom_namespaceObject = require("react-dom");
var external_react_dom_default = /*#__PURE__*/__webpack_require__.n(external_react_dom_namespaceObject);
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(6168);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/_shared/_wrappers/KeyDownHandler/KeyDownHandler.tsx


var _excluded = ["escapePress", "enterPress", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


/**
 * Wrapper for capturing key down functionality.
 * Executes prop `escapePress` function when Escape key is pressed.
 * Executes prop `enterPress` function when Enter key is pressed.
 * @param props
 * @since 1.0.0
 */

function KeyDown(props) {
  var escapePress = props.escapePress,
    enterPress = props.enterPress,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var container = (0,external_react_.useRef)(null);
  var keydownHandler = function keydownHandler(event) {
    var key = event.key;
    if (key === 'Escape' && escapePress) {
      escapePress();
    }
    if (key === 'Enter' && enterPress) {
      event.preventDefault();
      enterPress();
    }
  };
  (0,external_react_.useEffect)(function () {
    var currentContainer = container.current || undefined;
    currentContainer === null || currentContainer === void 0 || currentContainer.addEventListener('keydown', keydownHandler);
    return function () {
      currentContainer === null || currentContainer === void 0 || currentContainer.removeEventListener('keydown', keydownHandler);
    };
  });
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("div", _objectSpread(_objectSpread({
    className: "able-KeyDown",
    tabIndex: -1,
    ref: container
  }, other), {}, {
    children: children
  }));
}
/* harmony default export */ const KeyDownHandler = (KeyDown);
// EXTERNAL MODULE: ./src/_shared/_wrappers/KeyDownHandler/KeyDownHandler.scss
var KeyDownHandler_KeyDownHandler = __webpack_require__(4848);
;// ./src/_shared/_wrappers/KeyDownHandler/index.ts


/* harmony default export */ const _wrappers_KeyDownHandler = (KeyDownHandler);
;// ./src/ModalDialog/ModalDialogBase.tsx


function ModalDialogBase(props) {
  var classes = props.classes,
    children = props.children,
    ariaLabelledby = props.ariaLabelledby,
    innerRef = props.innerRef,
    _props$isShowing = props.isShowing,
    isShowing = _props$isShowing === void 0 ? false : _props$isShowing,
    escapeKeyPress = props.escapeKeyPress,
    enterKeyPress = props.enterKeyPress,
    id = props.id;
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("div", {
    id: id,
    className: classes,
    role: "dialog",
    ref: innerRef,
    "aria-labelledby": ariaLabelledby,
    "aria-modal": "true",
    "aria-hidden": !isShowing ? true : undefined,
    children: /*#__PURE__*/(0,jsx_runtime_.jsx)(_wrappers_KeyDownHandler, {
      escapePress: escapeKeyPress,
      enterPress: enterKeyPress,
      children: children
    })
  });
}
/* harmony default export */ const ModalDialog_ModalDialogBase = (ModalDialogBase);
// EXTERNAL MODULE: ./src/ModalDialog/hooks.ts
var hooks = __webpack_require__(7962);
;// ./src/ModalDialog/ModalDialog.tsx


var ModalDialog_excluded = ["children", "className", "enterKeyPress", "escapeKeyPress", "description", "developmentUrl", "icon", "title", "isShowing"];
function ModalDialog_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ModalDialog_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ModalDialog_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ModalDialog_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






/**
 * A modal dialog is used to interrupt user's current workflow, and bring their
 * attention exclusively to a decision or a piece of urgent information relevant to
 * their current context.
 *
 * [View the ModalDialog pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Modal+Dialog)
 *
 * @version 1.0.0
 */

function ModalDialog(props) {
  var children = props.children,
    className = props.className,
    enterKeyPress = props.enterKeyPress,
    escapeKeyPress = props.escapeKeyPress,
    description = props.description,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    title = props.title,
    _props$isShowing = props.isShowing,
    isShowing = _props$isShowing === void 0 ? false : _props$isShowing,
    other = objectWithoutProperties_default()(props, ModalDialog_excluded);
  var focusableEl = (0,external_react_.useRef)(null);
  var dialog = (0,external_react_.useRef)();
  var titleId = (0,external_react_.useId)();

  //dialog custom hooks
  (0,hooks/* useKeyboardTrap */.y)(dialog, isShowing, focusableEl);
  var enterPress = enterKeyPress ? function () {
    return enterKeyPress();
  } : undefined;
  var escapePress = escapeKeyPress ? function () {
    return escapeKeyPress();
  } : undefined;
  (0,external_react_.useLayoutEffect)(function () {
    if (isShowing) {
      var _focusableEl$current;
      // focus something for accessibility
      focusableEl === null || focusableEl === void 0 || (_focusableEl$current = focusableEl.current) === null || _focusableEl$current === void 0 || _focusableEl$current.focus();
    }
  }, [isShowing]);
  var RenderDialog = function RenderDialog() {
    (0,hooks/* useDisableBodyScroll */.d)();
    return /*#__PURE__*/(0,jsx_runtime_.jsx)(ModalDialog_ModalDialogBase, ModalDialog_objectSpread(ModalDialog_objectSpread({
      classes: className,
      "aria-hidden": !isShowing
    }, other), {}, {
      innerRef: dialog,
      isShowing: isShowing,
      escapeKeyPress: escapePress,
      enterKeyPress: enterPress,
      ariaLabelledby: titleId,
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
        className: "".concat(className, "__content"),
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("div", {
          className: "".concat(className, "__icon"),
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
            developmentUrl: developmentUrl,
            icon: icon,
            size: "24",
            screenReaderContent: icon
          })
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("h2", {
          tabIndex: -1,
          ref: focusableEl,
          id: titleId,
          children: title
        }), description ? /*#__PURE__*/(0,jsx_runtime_.jsx)("p", {
          children: description
        }) : '', children]
      })
    }));
  };
  return /*#__PURE__*/external_react_dom_default().createPortal(isShowing ? /*#__PURE__*/(0,jsx_runtime_.jsx)(RenderDialog, {}) : '', document.body);
}
var dialogStateStorybookArgTypes = {
  isShowing: {
    description: 'Boolean which shows and hides the dialog'
  },
  setHideDialog: {
    description: 'setState function linked to `isShowing` to trigger hiding and showing the dialog',
    control: {
      type: null
    }
  }
};
/* harmony default export */ const ModalDialog_ModalDialog = (ModalDialog);
;// ./src/ModalDialog/index.ts






/* harmony default export */ const src_ModalDialog = (ModalDialog_ModalDialog);

/***/ }),

/***/ 8732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ }),

/***/ 8737:
/***/ (() => {



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_ModalDialogConfirmation)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// ./src/ModalDialog/functions/createClickHandler.tsx
/**
 * Used in the Modal Dialog to combine external click handlers with internal state handlers
 *
 * @param events an object containing injected event handlers
 * @param setHideDialog function to combine with inject click handlers
 *
 * @returns a new function which when called triggers setHideDialog as well as the injected events
 */

var createClickHandler = function createClickHandler(events, setHideDialog) {
  return function () {
    if (typeof setHideDialog !== 'undefined') {
      setHideDialog();
    }
    if (typeof events !== 'undefined' && typeof events.onClick === 'function') {
      events.onClick();
    }
  };
};
;// ./src/ModalDialog/functions/createCollatedEvents.tsx

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Used in the Modal Dialog to combine external click handlers with internal state handlers
 *
 * @param event an object containing injected event handlers
 * @param clickHandler function to combine with inject click handlers
 *
 * @returns an events object concatenating injected events and onclick
 */

var createCollatedEvents = function createCollatedEvents(events, clickHandler) {
  return _objectSpread(_objectSpread({}, events), {}, {
    onClick: function onClick() {
      return clickHandler();
    }
  });
};
// EXTERNAL MODULE: ./src/ModalDialog/index.ts + 5 modules
var ModalDialog = __webpack_require__(8109);
// EXTERNAL MODULE: ./src/ActionButton/index.ts + 3 modules
var ActionButton = __webpack_require__(6963);
// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(7826);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
;// ./src/_shared/_hooks/useToggle.tsx


/**
 * Helper to be used to manage `isShowing` state of ModalDialog
 *
 * @param initialValue - the current value of isShowing
 *
 * @returns {[boolean, Function]} React state property and change function
 */

function useToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useState = (0,external_react_.useState)(initialValue),
    _useState2 = slicedToArray_default()(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var toggle = (0,external_react_.useCallback)(function () {
    setValue(function (v) {
      return !v;
    });
  }, []);
  return [value, toggle];
}
/* harmony default export */ const _hooks_useToggle = (useToggle);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/_shared/_wrappers/ModalDialogState/ModalDialogState.tsx


function ModalDialogState_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ModalDialogState_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ModalDialogState_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ModalDialogState_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




/**
 * Handles open/close state of dialog internally
 * @param {ComponentType} InternalDialogContent The main dialog element
 * @param {ReactElement} triggerElement The element (button) to trigger the opening of the ModalDialog
 * @param {MutableRefObject} focusOnCloseRef The external function to focus
 * the element that triggers opening the ModalDialog
 *
 * @returns {ReactElement} a wrapped ModalDialog including a trigger element that handles its own state
 */

var DialogStateWrapper = function DialogStateWrapper(_ref) {
  var InternalDialogContent = _ref.InternalDialogContent,
    triggerElement = _ref.triggerElement;
  var _useToggle = _hooks_useToggle(),
    _useToggle2 = slicedToArray_default()(_useToggle, 2),
    isShowing = _useToggle2[0],
    setHideDialog = _useToggle2[1];
  var clonedTriggerElement;
  if (triggerElement) {
    var triggerProps = triggerElement.props;
    var events = triggerProps.events;
    var triggerClickHandler = createClickHandler(events, setHideDialog);
    clonedTriggerElement = /*#__PURE__*/(0,external_react_.cloneElement)(triggerElement, ModalDialogState_objectSpread(ModalDialogState_objectSpread({}, triggerProps), {}, {
      events: {
        onClick: triggerClickHandler
      }
    }));
  }
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
    children: [clonedTriggerElement, /*#__PURE__*/(0,jsx_runtime_.jsx)(InternalDialogContent, {
      dialogContentIsShowing: isShowing,
      dialogContentSetHideDialog: setHideDialog
    })]
  });
};
/* harmony default export */ const ModalDialogState = (DialogStateWrapper);
;// ./src/_shared/_wrappers/ModalDialogState/index.ts

/* harmony default export */ const _wrappers_ModalDialogState = (ModalDialogState);
;// ./src/ModalDialog/functions/hideDialogClickHandler.tsx
var hideDialogClickHandlerTemplate = function hideDialogClickHandlerTemplate(hideDialog, focusOnCloseRef) {
  return function () {
    var _focusOnCloseRef$curr;
    hideDialog();
    focusOnCloseRef === null || focusOnCloseRef === void 0 || (_focusOnCloseRef$curr = focusOnCloseRef.current) === null || _focusOnCloseRef$curr === void 0 || _focusOnCloseRef$curr.focus();
  };
};
/* harmony default export */ const functions_hideDialogClickHandler = (hideDialogClickHandlerTemplate);
;// ./src/ModalDialogConfirmation/ModalDialogConfirmation.tsx

function ModalDialogConfirmation_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ModalDialogConfirmation_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ModalDialogConfirmation_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ModalDialogConfirmation_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






/**
 * A modal dialog is used to interrupt user's current workflow, and bring their
 * attention exclusively to a decision or an urgent information relevant to
 * their current context.
 *
 * [View the ModalDialog pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Modal+Dialog)
 *
 * @version 1.0.0
 */

var modalDialogConfirmationTemplate = function modalDialogConfirmationTemplate(icon) {
  var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (props) {
    var isShowing = props.isShowing,
      setHideDialog = props.setHideDialog,
      className = props.className,
      stackButtonOnVXS = props.stackButtonOnVXS,
      cancelButtonEvents = props.cancelButtonEvents,
      confirmButtonEvents = props.confirmButtonEvents,
      cancelButtonLabel = props.cancelButtonLabel,
      confirmButtonLabel = props.confirmButtonLabel,
      children = props.children,
      title = props.title,
      description = props.description,
      developmentUrl = props.developmentUrl,
      focusOnCloseRef = props.focusOnCloseRef;
    var stackedClass = stackButtonOnVXS ? '--stacked' : '';
    var patternClass = "able-ModalDialog--Confirmation".concat(variant).concat(stackedClass);
    var classes = classnames_default()(className, patternClass);
    var clickHandlerTemplate = function clickHandlerTemplate(dialogContentSetHideDialog) {
      return function (events) {
        return createClickHandler(events, dialogContentSetHideDialog);
      };
    };
    var ModalDialogContent = function ModalDialogContent(_ref) {
      var dialogContentIsShowing = _ref.dialogContentIsShowing,
        dialogContentSetHideDialog = _ref.dialogContentSetHideDialog;
      var hideDialogClickHandler = functions_hideDialogClickHandler(dialogContentSetHideDialog, focusOnCloseRef);
      var cancelButtonClickHandler = clickHandlerTemplate(hideDialogClickHandler)(cancelButtonEvents);
      var collatedCancelButtonEvents = createCollatedEvents(cancelButtonEvents, cancelButtonClickHandler);
      var confirmButtonClickHandler = clickHandlerTemplate(hideDialogClickHandler)(confirmButtonEvents);
      var collatedConfirmButtonEvents = createCollatedEvents(confirmButtonEvents, confirmButtonClickHandler);
      var newProps = {
        isShowing: dialogContentIsShowing,
        title: title,
        description: description,
        developmentUrl: developmentUrl,
        escapeKeyPress: cancelButtonClickHandler
      };
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(ModalDialog["default"], ModalDialogConfirmation_objectSpread(ModalDialogConfirmation_objectSpread({}, newProps), {}, {
        icon: icon,
        className: classes,
        children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", {
          className: "".concat(patternClass, "__actions"),
          children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(ActionButton["default"], {
            variant: "MediumEmphasis",
            element: "button",
            label: cancelButtonLabel,
            events: collatedCancelButtonEvents
          }), /*#__PURE__*/(0,jsx_runtime_.jsx)(ActionButton["default"], {
            variant: variant === 'Destructive' ? 'HighEmphasisDestructive' : 'HighEmphasis',
            element: "button",
            label: confirmButtonLabel,
            events: collatedConfirmButtonEvents
          })]
        })
      }));
    };
    if (typeof isShowing === 'undefined' && !setHideDialog && children) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(_wrappers_ModalDialogState, {
        InternalDialogContent: ModalDialogContent,
        triggerElement: children
      });
    }
    if (typeof isShowing !== 'undefined' && setHideDialog) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(ModalDialogContent, {
        dialogContentIsShowing: isShowing,
        dialogContentSetHideDialog: setHideDialog
      });
    }
    return /*#__PURE__*/(0,jsx_runtime_.jsx)(jsx_runtime_.Fragment, {});
  };
};
var ModalDialogConfirmation = modalDialogConfirmationTemplate('Attention');
/* harmony default export */ const ModalDialogConfirmation_ModalDialogConfirmation = (ModalDialogConfirmation);
// EXTERNAL MODULE: ./src/ModalDialogConfirmation/ModalDialogConfirmation.scss
var src_ModalDialogConfirmation_ModalDialogConfirmation = __webpack_require__(8737);
;// ./src/ModalDialogConfirmation/index.ts


/* harmony default export */ const src_ModalDialogConfirmation = (ModalDialogConfirmation_ModalDialogConfirmation);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});